import RBI from "../assets/RBI.webp";
import { BsPatchCheckFill } from "react-icons/bs";
import Poweredby from "../assets/poweredby.webp";
import Currency from "../../eximpe-tools/CurrencyCalculator";
import Avatars from "../assets/avatars2.webp";
import Btn from "../resuable-components/Button";
import { trackSignupEvent } from '../../../utlis/useAnalytics';

export default function Hero() {

  const btnClick = () => {
    trackSignupEvent({
      page: 'Global Collection Page',
      section: 'Hero SignUp',
    });
  };
  
  return (
    <div className="w-full container mx-auto px-4 sm:px-6 lg:px-10 xl:px-[10%] py-8 sm:py-10 md:py-12">
      

      <div className="flex flex-col lg:flex-row items-start gap-8 lg:mt-20 lg:ml-10 lg:gap-12">
        {/* Left Content Section */}
        <div className="flex flex-col w-full lg:w-1/2 space-y-6 md:space-y-8">
          {/* Highlight Badge */}
          <div className="flex bg-[#d6eee8] p-2 sm:p-3 rounded-2xl items-center gap-x-2 sm:gap-x-4 self-center lg:self-start">
            <BsPatchCheckFill className="text-[#149387] text-xl sm:text-2xl" />
            <p className="text-sm sm:text-base font-bold text-[#1A202C]">
              Lowest platform fees of 0.75%
            </p>
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl text-[#1A202C] font-bold text-center lg:text-left leading-tight">
            Unmatched Savings on Global Payments
          </h1>

          {/* Subheading */}
          <p className="text-[#6a7282] text-center lg:text-left text-base sm:text-lg md:text-xl lg:pr-12">
            Accept local payments in 100+ countries with{" "}
            <b className="text-[#27a887]">Zero FX Markup</b> and{" "}
            <b className="text-[#27a887]">Instant e-FIRA</b> generation
          </p>

          {/* Sign Up Button */}
          <div className="flex justify-center lg:justify-start w-full">
            <Btn onClick={btnClick} />
          </div>

          {/* Promotional Image */}
          <div className="flex justify-center lg:justify-start w-full">
            <img
              src={Avatars}
              alt="Promotional Visual"
              loading="eager"
              decoding="async"
              className="w-48 sm:w-64 md:w-72 lg:w-80 object-contain"
            />
          </div>
        </div>

        {/* Currency Converter Component */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
          <Currency />
        </div>
      </div>

      {/* RBI and Powered By Images */}
      <div className="mt-12 md:mt-32 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10">
        <img
          src={RBI}
          className="w-64 sm:w-72 md:w-80 rounded-2xl"
          alt="RBI logo"
        />
        <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
          <span className="text-base md:text-lg font-medium">Powered By:</span>
          <img
            src={Poweredby}
            className="w-[500px]"
            alt="Powered by logo"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
}
